import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { AdminOrderRow } from '../components/admin/AdminOrderRow';
import { Button } from '../components/ui/button';
import { Pagination } from '../components/ui/pagination';
import { useAdminOrders } from '../hooks/useAdminOrders';
import { useAuth } from '../hooks/useAuth';
import { useAuthModal } from '../providers';

export function AdminOrdersPage() {
  const { data: user, isLoading: authLoading } = useAuth();
  const authModal = useAuthModal();
  const [page, setPage] = useState(1);
  const { data, isLoading, isError } = useAdminOrders(page);
  const orders = data?.orders ?? [];
  const totalPages = Math.max(1, Math.ceil((data?.total ?? 0) / (data?.pageSize ?? 10)));

  if (authLoading) return <p className="section-pad mono-label">ЗАВАНТАЖЕННЯ…</p>;

  if (!user) {
    return (
      <div className="section-pad text-center">
        <p className="mb-4 text-[15px] text-muted">Увійдіть, щоб переглянути замовлення.</p>
        <Button variant="accent" size="lg" onClick={() => authModal.open('login')}>
          УВІЙТИ
        </Button>
      </div>
    );
  }

  if (user.role !== 'admin') return <Navigate to="/" replace />;
  if (isLoading) return <p className="section-pad mono-label">ЗАВАНТАЖЕННЯ…</p>;
  if (isError) return <p className="section-pad mono-label">Не вдалося завантажити замовлення.</p>;

  return (
    <div className="section-pad">
      <h1 className="mb-8 text-[clamp(32px,6vw,72px)] font-extrabold tracking-[-0.045em]">
        Замовлення
      </h1>
      {orders.length === 0 ? (
        <p className="text-[15px] text-muted">Замовлень ще немає.</p>
      ) : (
        <>
          <div className="divide-y divide-line-soft border border-line">
            {orders.map((order) => (
              <AdminOrderRow key={order.id} order={order} />
            ))}
          </div>
          <Pagination page={page} totalPages={totalPages} onPageChange={setPage} />
        </>
      )}
    </div>
  );
}
